import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDocumentExtractedData({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentExtractedDataDocumentsKeyExtractedDataGetOptions({
      path: { key: documentKey },
    }),
  })
}
